import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { SelectInputWTitle } from './SelectInputWTitle'
const Styles = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 0.5rem;
    direction: ltr;
`

    // dokme chesm baray ramz ha

export const SelectDateInput = ({style, name, error, value, onchange, required}) => {
    const [year, setYear] = useState(1400);
    const [month, setMonth] = useState(1);
    const [day, setDay] = useState(1);
    const [date, setDate] = useState('1382/1/1');

    useEffect(()=> {
        if(value){
            let temp = value.split('/');
            setYear(parseInt(temp[2]));
            setMonth(parseInt(temp[1]));
            setDay(parseInt(temp[0]));
        }
    },[value])

    const makeDays = () => {
        let temp = Math.abs(year - kabiseh)%4;
        let days = 0
        if(temp === 0){
            if(month === 12){
                days = 30;
            } else {
                days = months[month -1].days;
            }
        } else {
            days = months[month -1].days;
        }
        let options = [];
        for (let i = 0; i < days; i++) {
           options.push({
               value: i + 1,
               name: i + 1,
           })
        }
        return options;
    }
    const makeMonths = () => {
        let options = [];
        for (let i = 0; i < months.length; i++) {
            const element = months[i];
            options.push({
                value: i + 1,
                name: element.name,
            });
        }
        return options;
    }
    const makeYears = () => {
        let options = [];
        for (let i = 1402; i > 1300; i--) {
            options.push({
                value: i,
                name: i,
            });
        }
        return options;
    }
    const onchangeForm = (e) => {
        let value = parseInt(e.target.value);
        // console.log(value, e.target.name)
        let change = {
            target: {
                name: name,
                value: '',
            }
        }
        switch (e.target.name) {
            case "year":
                setYear(value);
                setDate(`${day}/${month}/${value}`);
                change.target.value = `${day}/${month}/${value}`;
                onchange(change);
                break;
            case "month":
                setMonth(value);
                setDate(`${day}/${value}/${year}`);
                change.target.value = `${day}/${value}/${year}`;
                onchange(change);
                break;
            case "day":
                setDay(value);
                setDate(`${value}/${month}/${year}`);
                change.target.value = `${value}/${month}/${year}`;
                onchange(change);
                break;
            default:
            break;
        }
    };
    return (
        <Styles style={style}>
            <input type={'hidden'} value={date}/>
            <SelectInputWTitle title={'Year'} name={'year'} value={year} options={makeYears()} error={''} onchange={onchangeForm}/>
            <SelectInputWTitle title={'Month'} name={'month'} value={month} options={makeMonths()} error={''} onchange={onchangeForm}/>
            <SelectInputWTitle title={'Day'} name={'day'} value={day} options={makeDays()} error={''} onchange={onchangeForm}/>
        </Styles>
    )
}

const kabiseh = 1399;

const months = [
    {
      name: "1",
      days: 31,
    },
    {
      name: "2",
      days: 31,
    },
    {
      name: "3",
      days: 31,
    },
    {
      name: "4",
      days: 31,
    },
    {
      name: "5",
      days: 31,
    },
    {
      name: "6",
      days: 31,
    },
    {
      name: "7",
      days: 30,
    },
    {
      name: "8",
      days: 30,
    },
    {
      name: "9",
      days: 30,
    },
    {
      name: "10",
      days: 30,
    },
    {
      name: "11",
      days: 30,
    },
    {
      name: "12",
      days: 29,
    },
];